module.exports = "/packs/course-writing-first-cc711b65f79c407050efa84b7d814b62.png";